/* eslint-disable react/prop-types */
import React, { useState, useEffect } from 'react';
import BetaProgramPopup from './beta';

export default function TimedPopup({ enabled, isBlocked, onClick, delay, block, content, okText, cancelText }) {
  const [isOpen, setIsOpen] = useState(false);
  useEffect(() => {
    if (enabled && !isBlocked()) {
      setTimeout(() => {
        setIsOpen(true);
      }, delay);
    }
  }, [enabled]);
  return (
    <BetaProgramPopup
      isOpen={isOpen}
      onClose={() => setIsOpen(false)}
      align="center"
      onClick={() => {
        onClick();
      }}
      onBlock={() => {
        block();
      }}
      content={content}
      okText={okText}
      cancelText={cancelText}
    />
  );
}
